import * as logger from '../../../abt-utils/logger'
import * as queryString from '../../../abt-utils/query-string'
import { contains as pageDataContains } from '../../../abt-utils/page-data'
import { applyDefault } from '../../../abt-utils/structure'

export function customCriteria (test) {
  var isDeals = pageDataContains('uberCatName', test.customData.uberCatName)
  var isPdp = pageDataContains('pageType', test.customData.pageType)
  var referredFromDeals = !!queryString.get('abtref')
  return (isDeals || (isPdp && referredFromDeals)) ? test : null
}

export function a (test) {
  return test
}

export function b (test) {
  var isDeals = pageDataContains('uberCatName', test.customData.uberCatName)

  if (isDeals) {
    return System.import('./b-deals')
      .then(applyDefault(test))
      .catch(logger.error)
  } else {
    return System.import('./b-pdp')
      .then(applyDefault(test))
      .catch(logger.error)
  }
}



/*****************
 ** WEBPACK FOOTER
 ** ./src/abt-tests/abt520/large/index.js
 ** module id = 52
 ** module chunks = 2
 **/